import React, { useEffect, useState, useRef } from 'react'
import AceEditor from 'react-ace'
import Beautify from 'ace-builds/src-noconflict/ext-beautify'

import 'ace-builds/src-noconflict/ext-emmet'
import 'ace-builds/src-noconflict/ext-static_highlight'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/theme-kuroir'
import Tiptap from './Tiptap'
import Client from '../../models/client'

// --- Styles for the new tab UI ---
const tabContainerStyle = {
  display: 'flex',
  borderBottom: '1px solid #ccc',
  marginBottom: '10px',
}

const tabStyle = {
  padding: '10px 15px',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  color: '#555',
  outline: 'none',
}

const activeTabStyle = {
  ...tabStyle,
  borderBottom: '2px solid var(--mantine-color-invy-6)',
  color: 'var(--mantine-color-invy-6)',
  fontWeight: 'bold',
}
// --- End of new styles ---

export interface Props {
  initialValue: string
  onChange: (text: string) => void
  client: Client
}

const CodeEditor = ({
  value,
  onChange,
}: {
  value: string
  onChange: (text: string) => void
}) => {
  const editorRef = useRef<AceEditor>(null)

  const beautifyContent = () => {
    if (editorRef.current) {
      const editor = editorRef.current.editor
      Beautify.beautify(editor.session)
    }
  }

  useEffect(() => {
    // Tiptapから切り替わった際に、minifyされたHTMLを整形するために実行
    beautifyContent()
  }, [])

  return (
    <div style={{ width: '100%' }}>
      <AceEditor
        ref={editorRef}
        mode="html"
        theme="kuroir"
        value={value}
        onChange={onChange}
        editorProps={{ $blockScrolling: true }}
        width="100%"
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          enableEmmet: true,
          tabSize: 2,
        }}
      />
    </div>
  )
}

const CouponContentEditor = ({ initialValue, onChange, client }: Props) => {
  const [content, setContent] = useState(initialValue ?? '')
  const [activeEditor, setActiveEditor] = useState<'visual' | 'code'>('visual')

  useEffect(() => {
    setContent(initialValue ?? '')
  }, [initialValue])

  useEffect(() => {
    onChange(content)
  }, [content, onChange])

  return (
    <div style={{ width: '100%' }}>
      <div style={tabContainerStyle}>
        <button
          type="button" // formのsubmitを防ぐ
          style={activeEditor === 'visual' ? activeTabStyle : tabStyle}
          onClick={() => setActiveEditor('visual')}>
          リッチエディタ
        </button>
        <button
          type="button" // formのsubmitを防ぐ
          style={activeEditor === 'code' ? activeTabStyle : tabStyle}
          onClick={() => setActiveEditor('code')}>
          HTMLエディタ
        </button>
      </div>

      <div>
        {activeEditor === 'code' ? (
          <CodeEditor value={content} onChange={setContent} />
        ) : (
          <Tiptap value={content} onChange={setContent} client={client} />
        )}
      </div>
    </div>
  )
}

export default CouponContentEditor
